"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
/**
 * Thrown when a mandatory parameter is missing
 * @param {Array.<string>} attributeNames
 */
class MissingAttributesError extends client_library_1.ExtendableError {
    constructor(attributeNames) {
        super(`Missing attribute: ${attributeNames}`);
    }
}
exports.default = MissingAttributesError;
